import { Box } from "@qws-org/ui-kit";
import type { FC } from "react";

import { BLOCK_MIN_HEIGHTS, type BlockType } from "./min-heights";

type MinHeightPlaceholderProps = {
  blockType: BlockType;
};

export const MinHeightPlaceholder: FC<MinHeightPlaceholderProps> = ({
  blockType,
}) => {
  const { mobile, tablet, desktop } = BLOCK_MIN_HEIGHTS[blockType];

  return (
    <Box
      minHeight={mobile}
      md={{ minHeight: tablet }}
      d={{ minHeight: desktop }}
    />
  );
};
